// extracted by mini-css-extract-plugin
module.exports = {"InternshipsList__item":"InternshipsList_InternshipsList__item__2LQG-"};